import { ModalContent, ModalFooter } from '@components/modal';
import { connect } from 'redux-bundler-react';
import { useRequest } from '@stores';
import { RequestTypeStrings } from '@src/utils/enums';
import { Alert } from '@trussworks/react-uswds';

const SubmissionModal = connect(
  'selectRequestFormData',
  ({ requestFormData, title = 'Request Submitted', msg, status, onSave, saveText = 'OK', cancelText }) => {
    const { selectedRequestId } = useRequest();
    const district = requestFormData?.location?.district ?? '';
    const requestTypeLabel = RequestTypeStrings[selectedRequestId] ?? 'Request';
    const showWarning = msg && ['Success With Warning', 'Warning'].includes(String(status));

    return (
      <ModalContent title={title}>
        <section className='modal-body'>
          <div className='container-fluid'>
            {showWarning && (
              <Alert slim type='warning' className='margin-bottom-1'>
                {msg}
              </Alert>
            )}
            <span>
              Your <span className='text-bold'>{requestTypeLabel}</span> request has been submitted to the{' '}
              <span className='text-bold'>{district}</span>.
            </span>
            <span style={{ display: 'block', marginTop: 8 }}>
              Please contact your local Regulatory office with any questions/concerns.
            </span>
          </div>
        </section>
        <ModalFooter saveText={saveText} showCancelButton={cancelText} onSave={onSave} cancelText={cancelText} />
      </ModalContent>
    );
  }
);

export default SubmissionModal;
